"use client";

import { motion } from "framer-motion";

export default function PageBanner({ title, description, Icon }) {
  return (
    <section className="relative py-10 sm:py-16 lg:py-24 overflow-hidden border-b-4 border-[#006699]">
      {/* SCOPED BACKGROUND */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('/bg.webp')",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
        }}
      />

      {/* BLUE OVERLAY */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background: "linear-gradient(135deg, rgba(0,102,153,0.88) 0%, rgba(0,34,51,0.95) 100%)",
        }}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-10 relative z-10">
        <div className="flex items-center justify-between gap-4 sm:gap-8 md:gap-12">
          
          {/* TITLE & DESCRIPTION */}
          <div className="flex items-stretch gap-3 sm:gap-6 md:gap-8 max-w-2xl flex-1 min-w-0">
            {/* Vertical Accent Line */}
            <motion.div 
              initial={{ scaleY: 0 }}
              animate={{ scaleY: 1 }}
              transition={{ duration: 0.8, ease: "circOut" }}
              className="w-[3px] bg-[#7dd3fc] block shrink-0"
            />
            
            <div className="flex flex-col justify-center min-w-0">
              <motion.h1
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-1 sm:mb-2.5 tracking-wider sm:tracking-widest uppercase leading-tight truncate sm:whitespace-normal"
              >
                {title}
              </motion.h1>
              
              {description && (
                <motion.p
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.35 }}
                  className="text-[11px] sm:text-sm md:text-base text-white/75 font-light leading-snug sm:leading-relaxed tracking-normal sm:tracking-wide line-clamp-2 sm:line-clamp-none max-w-md sm:max-w-xl"
                >
                  {description}
                </motion.p>
              )}
            </div>
          </div>

          {/* ICON: Clearly visible and prominent on mobile & desktop */}
          {Icon && (
            <motion.div
              initial={{ opacity: 0, scale: 0.85, x: 10 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.25 }}
              className="text-[#7dd3fc] drop-shadow-[0_0_20px_rgba(125,211,252,0.45)] w-14 h-14 sm:w-24 sm:h-24 md:w-36 md:h-36 lg:w-44 lg:h-44 shrink-0 flex items-center justify-center p-1"
            >
              <Icon size="100%" strokeWidth={1.5} />
            </motion.div>
          )}

        </div>
      </div>
    </section>
  );
}
